export default [
    {
        kram: 1,
        title: "Apple",
        axar: "A",
        image: "bal_vibhag/paku_kariye/abcd/a.png",
    },
    {
        kram: 2,
        title: "Ball",
        axar: "B",
        image: "bal_vibhag/paku_kariye/abcd/b.png",
    },
    {
        kram: 3,
        title: "Cat",
        axar: "C",
        image: "bal_vibhag/paku_kariye/abcd/c.png",
    },
    {
        kram: 4,
        title: "Dog",
        axar: "D",
        image: "bal_vibhag/paku_kariye/abcd/d.png",
    },
    {
        kram: 5,
        title: "Elephant",
        axar: "E",
        image: "bal_vibhag/paku_kariye/abcd/e.png",
    },
    {
        kram: 6,
        title: "Fish",
        axar: "F",
        image: "bal_vibhag/paku_kariye/abcd/f.png",
    },
    {
        kram: 7,
        title: "Grapes",
        axar: "G",
        image: "bal_vibhag/paku_kariye/abcd/g.png",
    },
    {
        kram: 8,
        title: "Hen",
        axar: "H",
        image: "bal_vibhag/paku_kariye/abcd/h.png",
    },
    {
        kram: 9,
        title: "Ice-Cream",
        axar: "I",
        image: "bal_vibhag/paku_kariye/abcd/i.png",
    },
    {
        kram: 10,
        title: "Jug",
        axar: "J",
        image: "bal_vibhag/paku_kariye/abcd/j.png",
    },
    {
        kram: 11,
        title: "Kite",
        axar: "K",
        image: "bal_vibhag/paku_kariye/abcd/k.png",
    },
    {
        kram: 12,
        title: "Lion",
        axar: "L",
        image: "bal_vibhag/paku_kariye/abcd/l.png",
    },
    {
        kram: 13,
        title: "Mango",
        axar: "M",
        image: "bal_vibhag/paku_kariye/abcd/m.png",
    },
    {
        kram: 14,
        title: "Nest",
        axar: "N",
        image: "bal_vibhag/paku_kariye/abcd/n.png",
    },
    {
        kram: 15,
        title: "Orange",
        axar: "O",
        image: "bal_vibhag/paku_kariye/abcd/o.png",
    },
    {
        kram: 16,
        title: "Peacock",
        axar: "P",
        image: "bal_vibhag/paku_kariye/abcd/p.png",
    },
    {
        kram: 17,
        title: "Queen",
        axar: "Q",
        image: "bal_vibhag/paku_kariye/abcd/q.png",
    },
    {
        kram: 18,
        title: "Rabbit",
        axar: "R",
        image: "bal_vibhag/paku_kariye/abcd/r.png",
    },
    {
        kram: 19,
        title: "Ship",
        axar: "S",
        image: "bal_vibhag/paku_kariye/abcd/s.png",
    },
    {
        kram: 20,
        title: "Tiger",
        axar: "T",
        image: "bal_vibhag/paku_kariye/abcd/t.png",
    },
    {
        kram: 21,
        title: "Umbrella",
        axar: "U",
        image: "bal_vibhag/paku_kariye/abcd/u.png",
    },
    {
        kram: 22,
        title: "Van",
        axar: "V",
        image: "bal_vibhag/paku_kariye/abcd/v.png",
    },
    {
        kram: 23,
        title: "Watch",
        axar: "W",
        image: "bal_vibhag/paku_kariye/abcd/w.png",
    },
    {
        kram: 24,
        title: "Xylophone",
        axar: "X",
        image: "bal_vibhag/paku_kariye/abcd/x.png",
    },
    {
        kram: 25,
        title: "Yak",
        axar: "Y",
        image: "bal_vibhag/paku_kariye/abcd/y.png",
    },
    {
        kram: 26,
        title: "Zebra",
        axar: "Z",
        image: "bal_vibhag/paku_kariye/abcd/z.png",
    },
];
